// extracted by mini-css-extract-plugin
export default {"categorias":"styles_categorias__oLRzF","categoria":"styles_categoria__cK0k4","active":"styles_active__lx6sn","cards":"styles_cards__DXM3Z"};